import { FormGroup, Paper, TextField, Typography, Button} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState } from "react";
import { auth } from "../index";
import { signInWithEmailAndPassword, signOut } from "firebase/auth"
import { loginemail, savesignin, createsignin, getsignin, fetchEmployees } from "../api/customerapi";
import DateCalc from "./date";




const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8",
      marginTop: theme.spacing(10),
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(15),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
  }));

const Authscreen = () => {
    const classes = useStyles();

    const [authData, setauthData] =useState({
        email: "",
        password:"",
        
        });

        const handleSubmit =async (e) => {
            e.preventDefault();
            signInWithEmailAndPassword(auth, authData.email, authData.password)
                .then(async(userCredential) => {

                const user = userCredential.user;
                console.log(user);
                const data=await getsignin(user.email)
                console.log(data.data)
                if(data.data.length>0){
                    if("user" in data.data[data.data.length-1] && !(data.data[data.data.length-1].user=="debayan.ghosh@jetovacations.com" || data.data[data.data.length-1].user=="anumitapaul7@gmail.com") && "logged_in" in data.data[data.data.length-1] && data.data[data.data.length-1].logged_in){
                        alert("Cannot login with this id as it is already logged in by someone else")
                    }else{
                const data2=await savesignin(user.email, user.metadata.lastLoginAt)
                console.log(data2)
                window.location = ("/home");
                    }
                }else{
                    const data = await fetchEmployees(); 
                    var temp=data.data.filter(emp=>emp.email==user.email)
                    if(temp.length>0){
                        var data2=await createsignin(user.email)
                    }
                }
              
        })
             .catch((error) => {
                 alert("Incorrect credentials. Try again!")
             });
            
        }  
        
        const generatelink=async()=>{
            const data=await loginemail("aakansha@jetovacations.com")
            console.log(data)
            // auth
            // .createCustomToken("debayan.ghosh@jetovacations.com")
            // .then((customToken) => {
            //   return customToken;
            // })
            // .catch((error) => {
            //   console.log('Error creating custom token:', error);
            // });
        }

    return (
        <Paper variant="outlined" className={classes.paper} elevation={10}>
            <Typography variant="h4" align="center" className={classes.headertext}> Login</Typography>
            <form onSubmit={handleSubmit}>
            
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  label="Email"  value={authData.email} className={classes.textField} onChange={(e)=> setauthData({...authData, email: e.target.value.trim()})}/>
                <TextField variant="standard"  label="Password" type="password" value={authData.password} className={classes.textField} onChange={(e)=> setauthData({...authData, password: e.target.value.trim()})}/>
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Sign In</Button>
                {/* <Button variant="contained" color="primary" onClick={generatelink} className={classes.button}>Generate</Button> */}
            </FormGroup>
              
            </form>
        </Paper>
      );
}
 
export default Authscreen;